import { firestore } from '@src/api/Firebase/Firebase';
import { collection } from 'firebase/firestore';
import { Input } from '@api/Inputs/Input';
import { UserType } from '@api/Users/User';

export enum InventoryOrderStatus {
    requested = 'requested',
    pickupReady = 'pickupReady',
    inRoute = 'inRoute',
    received = 'received',
    canceled = 'canceled'
}

export interface InventoryOrderItem {
    input: Input;
    quantity: number;
    maxQuantity?: number;
}

export interface InventoryOrder {
    id?: string;
    shortId: string;
    status: InventoryOrderStatus;
    branchOfficeId: string;
    distributionCenterId: string;
    items: InventoryOrderItem[];
    date?: any; // Mantenido para compatibilidad y migración
    createdAt: any;
    note?: string;
    paymentStatus?: 'pending' | 'paid';
    subtotal?: number;
    total?: number;
    cashAmount?: number;
    creditCardAmount?: number;
    bankTransferAmount?: number;
    createdBy?: UserType;
}

export const INVENTORY_ORDERS_COLLECTION = 'inventory-orders';

export const inventoryOrdersRef = collection(firestore, INVENTORY_ORDERS_COLLECTION);

export const getInventoryOrderStatusName = (status: InventoryOrderStatus): string => {
    switch (status) {
        case InventoryOrderStatus.requested:
            return 'Solicitado';
        case InventoryOrderStatus.pickupReady:
            return 'Listo para el envío';
        case InventoryOrderStatus.inRoute:
            return 'En ruta';
        case InventoryOrderStatus.received:
            return 'Recibido';
        case InventoryOrderStatus.canceled:
            return 'Cancelado';
        default:
            return 'Desconocido';
    }
};

export const getInventoryOrderStatusColor = (
    status: InventoryOrderStatus
): 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' => {
    switch (status) {
        case InventoryOrderStatus.requested:
            return 'warning';
        case InventoryOrderStatus.pickupReady:
            return 'info';
        case InventoryOrderStatus.inRoute:
            return 'primary';
        case InventoryOrderStatus.received:
            return 'success';
        case InventoryOrderStatus.canceled:
            return 'error';
        default:
            return 'default';
    }
};

export const getInventoryOrderPaymentStatusName = (status?: 'pending' | 'paid'): string => {
    if (!status) return 'Sin estado';
    switch (status) {
        case 'pending':
            return 'Pendiente';
        case 'paid':
            return 'Pagado';
        default:
            return 'Desconocido';
    }
};

export const getInventoryOrderPaymentStatusColor = (
    status?: 'pending' | 'paid'
): 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' => {
    if (!status) return 'default';
    switch (status) {
        case 'pending':
            return 'warning';
        case 'paid':
            return 'success';
        default:
            return 'default';
    }
};
